module.exports = __webpack_public_path__ + "img/9.006443bf.jpg";